export default "__VITE_ASSET__9CQLqCrd__"